import type { AttentionKind } from '@tekansa/core/analytics';
import {
  CircleHelp,
  Flame,
  Globe,
  MailWarning,
  PauseCircle,
  Unplug,
  type LucideIcon,
} from 'lucide-react';

/** One icon per kind of "Needs your attention" / "Things to fix" line. */
export const ATTENTION_ICONS: Record<AttentionKind, LucideIcon> = {
  reconnect_mailboxes: Unplug,
  paused_mailboxes: PauseCircle,
  dns_domains: Globe,
  unknown_sends: CircleHelp,
  deliverability_alerts: MailWarning,
  warming_mailboxes: Flame,
};
